import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { clearCache } from "@/lib/cache";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=logged out

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = (data) => {
    localStorage.setItem("token", data.access_token);
    sessionStorage.removeItem("edit_unlocked");
    clearCache();
    setUser(data.user);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("token");
    sessionStorage.removeItem("edit_unlocked");
    clearCache();
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
